module.exports = __webpack_public_path__ + "static/img/kehuanli-1.60ac0f95.jpg";